import { authClient, getServiceURL, getURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { getServiceURLserverSide } from '@infrastructure/Urls'

const generateOrder = ({ projectId, lang }) => {
	let url = `${getURL(`/v2/orders/by-project/${projectId}`, 'api')}`

	return authClient.get(url, {
		params: {
			lang
		}
	})
}

const getProjectAndOrderByProjectId = ({ projectId, lang }) => {
	let url = `${getURL(`/v3/project/${projectId}/order`, 'api')}`

	return authClient.get(url, {
		params: {
			lang
		}
	})
}


const getOrder = ({ orderId, lang }) => {
	let url = `${getURL(`/v2/orders/${orderId}`, 'api')}`
	if (Toggles.isEnabled("unifiedCodeVersion")) {
		url = `${getServiceURLserverSide('v3')}/orders/${orderId}`
	}
	return authClient.get(url, {
		params: {
			lang
		}
	})
}

const validatePromoCode = ({ code, projectId, products, lang }) => {
	return authClient.post(`${getServiceURLserverSide('v3')}/promo-codes/validate`, { code, projectId, products }, {
		params: {
			lang
		}
	})
}

const processOrder = (order) => {

	const urlToFetch = getServiceURLserverSide('v3') + '/orders/process'

	return new Promise((resolve, reject) =>
		authClient
			.post(urlToFetch, order)
			.then((serviceResponse) => {
				resolve(serviceResponse)
			})
			.catch((error) => {
				if (error?.response?.status === 403) {
					resolve({
						...error,
						response: {
							...error.response,
							status: 403,
							processOrderSuccess: false,
							data: {
								status: 403
							}
						}
					})

				}
				if (error?.response?.status === 400 && error?.response?.data?.code === 'NO_CLIENT_CODE') {
					resolve({
						...error,
						response: {
							...error.response,
							status: 200,
							processOrderSuccess: false
						}
					})
				}
				if (error?.response?.status === 422) {
					resolve({
						...error,
						response: {
							...error.response,
							processOrderSuccess: false,
							data: {
								status: 422,
								message: error?.response?.data?.message,
								code: error?.response?.data?.code,
								reason: error?.response?.data?.reason
							}
						}
					})
				}
				reject(error)
			})
	)
}



export default {
	generateOrder,
	getOrder,
	processOrder,
	validatePromoCode,
	getProjectAndOrderByProjectId
}
